import React, { useEffect, useState } from "react";

import { makeStyles, Paper, Typography } from "@material-ui/core";

import InvestListView from "./InvestListView";

import { getInvestedList } from "./InvestFunctions";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "100%",
    minHeight: "200px",
    padding: theme.spacing(2),
    display: "flex",
    flexFlow: "column",
  },
}));
function InvestHistory({ network, selectedContract }) {
  const classes = useStyles();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  // List view
  const [expanded, setExpanded] = useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const get_invested_list = async () => {
    // start loading
    setLoading(true);

    // request
    await getInvestedList(
      network.account,
      selectedContract.contractAddress,
    ).then((res) => {
      setList(res);
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    if (selectedContract.contractAddress) {
      get_invested_list();
    }
  }, [selectedContract.name]);

  return (
    <Paper elevation={0} className={classes.paperContainer}>
      <Typography variant="h6" className="mb-3">
        Invest History
      </Typography>

      {(!selectedContract.name || loading || !list.length) && (
        <div className="h-100 d-flex align-items-center justify-content-center">
          <p className="mb-4">
            {!selectedContract.name
              ? "Select Contract"
              : loading
              ? "Loading..."
              : "No Invest To Show"}
          </p>
        </div>
      )}

      {!loading &&
        list.map((item) => (
          <InvestListView
            key={item.id}
            item={item}
            selectedContract={selectedContract}
            network={network}
            active={expanded === `panel${item.id}`}
            handleChange={handleChange}
            refreshData={() => get_invested_list()}
          />
        ))}
    </Paper>
  );
}

export default InvestHistory;
